import React from 'react';
import Screen from '../../shared/components/screen';
import {VisuallyImpairedProps} from '../../shared/components/visuallyImpaired/form/model';
import {VisuallyImpairedFormMobile} from '../../shared/components/visuallyImpaired/formMobile';
import {CustomScrollView} from '../../shared/components/scrollView';
import {useStyles} from '../../shared/hooks/styles';
import {getFontWeight} from '../../shared/theme/default';

export interface IStateProps extends VisuallyImpairedProps {
  onGoBackClick: () => void;
}

export default ({}: IStateProps) => {
  const styles = useStyles(({theme}) => ({
    fieldWrapper: {
      marginBottom: 36,
    },
    topBar: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      height: 54,
      paddingHorizontal: 12,
    },
    screenTitle: {
      fontWeight: getFontWeight('500'),
      fontFamily: theme.fonts.fontFamily.medium,
      fontSize: 16,
      lineHeight: 22,
      marginLeft: 19,
    },
    container: {
      paddingHorizontal: 20,
      paddingTop: 30,
    },
    settingContainer: {
      paddingBottom: theme.screen.bottomOffset,
    },
    settingLabel: {
      marginBottom: 12,
      fontFamily: 'Arial',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 16,
      lineHeight: 18,
    },
    fontSerifSettingLabel: {
      marginBottom: 18,
    },
  }));

  return (
    <Screen hideFooter={true}>
      <CustomScrollView
        style={styles.container}
        contentContainerStyle={styles.settingContainer}
        contentInsetAdjustmentBehavior='automatic'>
        <VisuallyImpairedFormMobile groupStyle={styles.fieldWrapper} />
      </CustomScrollView>
    </Screen>
  );
};
